export const SET_DISCOVERY_MODEL = 'SET_DISCOVERY_MODEL';
export const DISCOVERY_MODEL_PROBLEMS = 'DISCOVERY_MODEL_PROBLEMS';
export const SET_CONFIGURATION = 'SET_CONFIGURATION';
export const SET_CONFIGURATION_SIGNING_PRIVATE = 'SET_CONFIGURATION_SIGNING_PRIVATE';
export const SET_CONFIGURATION_SIGNING_PUBLIC = 'SET_CONFIGURATION_SIGNING_PUBLIC';
export const SET_CONFIGURATION_TRANSPORT_PRIVATE = 'SET_CONFIGURATION_TRANSPORT_PRIVATE';
export const SET_CONFIGURATION_TRANSPORT_PUBLIC = 'SET_CONFIGURATION_TRANSPORT_PUBLIC';
export const SET_TPP_SIGNATURE_KID = 'SET_TPP_SIGNATURE_KID';
export const SET_TPP_SIGNATURE_ISSUER = 'SET_TPP_SIGNATURE_ISSUER';
export const SET_TPP_SIGNATURE_TAN = 'SET_TPP_SIGNATURE_TAN';
export const SET_DISCOVERY_TEMPLATES = 'SET_DISCOVERY_TEMPLATES';
export const SET_WIZARD_STEP = 'SET_WIZARD_STEP';
export const SET_TRANSACTION_FROM_DATE = 'SET_TRANSACTION_FROM_DATE';
export const SET_TRANSACTION_TO_DATE = 'SET_TRANSACTION_TO_DATE';
export const SET_CLIENT_ID = 'SET_CLIENT_ID';
export const SET_CLIENT_SECRET = 'SET_CLIENT_SECRET';
export const SET_TOKEN_ENDPOINT = 'SET_TOKEN_ENDPOINT';
export const SET_RESPONSE_TYPE = 'SET_RESPONSE_TYPE';
export const SET_RESPONSE_TYPES_SUPPORTED = 'SET_RESPONSE_TYPES_SUPPORTED';
export const SET_TOKEN_ENDPOINT_AUTH_METHOD = 'SET_TOKEN_ENDPOINT_AUTH_METHOD';
export const SET_LETTER_OF_GUARANTEE = 'LETTER_OF_GUARANTEE';
export const SET_TOKEN_ENDPOINT_AUTH_METHODS = 'SET_TOKEN_ENDPOINT_AUTH_METHODS';
export const SET_REQUEST_OBJECT_SIGNING_ALG_VALUES_SUPPORTED = 'SET_REQUEST_OBJECT_SIGNING_ALG_VALUES_SUPPORTED';
export const SET_REQUEST_OBJECT_SIGNING_ALG = 'SET_REQUEST_OBJECT_SIGNING_ALG';
export const SET_AUTHORIZATION_ENDPOINT = 'SET_AUTHORIZATION_ENDPOINT';
export const SET_RESOURCE_BASE_URL = 'SET_RESOURCE_BASE_URL';
export const SET_X_FAPI_FINANCIAL_ID = 'SET_X_FAPI_FINANCIAL_ID';
export const SET_SEND_X_FAPI_CUSTOMER_IP_ADDRESS = 'SET_SEND_X_FAPI_CUSTOMER_IP_ADDRESS';
export const SET_X_FAPI_CUSTOMER_IP_ADDRESS = 'SET_X_FAPI_CUSTOMER_IP_ADDRESS';
export const SET_ISSUER = 'SET_ISSUER';
export const SET_REDIRECT_URL = 'SET_REDIRECT_URL';
export const SET_RESOURCE_ACCOUNT_ID = 'SET_RESOURCE_ACCOUNT_ID';
export const SET_RESOURCE_STATEMENT_ID = 'SET_RESOURCE_STATEMENT_ID';
export const SET_RESOURCE_ACCOUNT_IDS = 'SET_RESOURCE_ACCOUNT_IDS';
export const SET_RESOURCE_STATEMENT_IDS = 'SET_RESOURCE_STATEMENT_IDS';
export const ADD_RESOURCE_ACCOUNT_ID = 'ADD_RESOURCE_ACCOUNT_ID';
export const REMOVE_RESOURCE_ACCOUNT_ID = 'REMOVE_RESOURCE_ACCOUNT_ID';
export const ADD_RESOURCE_STATEMENT_ID = 'ADD_RESOURCE_STATEMENT_ID';
export const REMOVE_RESOURCE_STATEMENT_ID = 'REMOVE_RESOURCE_STATEMENT_ID';
export const SET_CREDITOR_ACCOUNT_NAME_SCHEME_NAME = 'SET_CREDITOR_ACCOUNT_NAME_SCHEME_NAME';
export const SET_CREDITOR_ACCOUNT_IDENTIFICATION = 'SET_CREDITOR_ACCOUNT_IDENTIFICATION';
export const SET_CREDITOR_ACCOUNT_NAME = 'SET_CREDITOR_ACCOUNT_NAME';
export const SET_DEBTOR_ACCOUNT_NAME_SCHEME_NAME = 'SET_DEBTOR_ACCOUNT_NAME_SCHEME_NAME';
export const SET_DEBTOR_ACCOUNT_IDENTIFICATION = 'SET_DEBTOR_ACCOUNT_IDENTIFICATION';
export const SET_DEBTOR_ACCOUNT_NAME = 'SET_DEBTOR_ACCOUNT_NAME';
export const SET_INTERNATIONAL_CREDITOR_ACCOUNT_NAME_SCHEME_NAME = 'SET_INTERNATIONAL_CREDITOR_ACCOUNT_NAME_SCHEME_NAME';
export const SET_INTERNATIONAL_CREDITOR_ACCOUNT_IDENTIFICATION = 'SET_INTERNATIONAL_CREDITOR_ACCOUNT_IDENTIFICATION';
export const SET_INTERNATIONAL_CREDITOR_ACCOUNT_NAME = 'SET_INTERNATIONAL_CREDITOR_ACCOUNT_NAME';
export const SET_INSTRUCTED_AMOUNT_VALUE = 'SET_INSTRUCTED_AMOUNT_VALUE';
export const SET_INSTRUCTED_AMOUNT_CURRENCY = 'SET_INSTRUCTED_AMOUNT_CURRENCY';
export const SET_CURRENCY_OF_TRANSFER = 'SET_CURRENCY_OF_TRANSFER';
export const SET_PAYMENT_FREQUENCY = 'SET_PAYMENT_FREQUENCY';
export const SET_FIRST_PAYMENT_DATE_TIME = 'SET_FIRST_PAYMENT_DATE_TIME';
export const SET_REQUESTED_EXECUTION_DATE_TIME = 'SET_REQUESTED_EXECUTION_DATE_TIME';
export const SET_CONDITIONAL_PROPERTIES = 'SET_CONDITIONAL_PROPERTIES';
export const SET_CBPII_DEBTOR_ACCOUNT_IDENTIFICATION = 'SET_CBPII_DEBTOR_ACCOUNT_IDENTIFICATION';
export const SET_CBPII_DEBTOR_ACCOUNT_NAME = 'SET_CBPII_DEBTOR_ACCOUNT_NAME';
export const SET_CBPII_DEBTOR_ACCOUNT_SCHEME_NAME = 'SET_CBPII_DEBTOR_ACCOUNT_SCHEME_NAME';
